import React, { useState, useMemo, useEffect } from 'react'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib'
import { Link } from 'react-router-dom'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import ProductForm from '../Product/ProductForm'
import { SurfaceCard, StatusPill, PageHeader, SideDrawer } from '../../Components/Ui'
import { navy, primary, muted } from '../../Components/Layout/Resources/Theme'

const eyebrowStyle = {
  fontSize: '0.68rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: primary,
  marginBottom: 4
}

const sectionTitleStyle = {
  color: navy,
  fontWeight: 700,
  margin: 0,
  fontSize: '1rem'
}

const nameStyle = { color: navy, margin: 0 }

const moreBtnStyle = {
  height: 32,
  padding: '0 12px',
  borderRadius: 10,
  border: '1px solid #E5E7EB',
  background: '#fff',
  color: navy,
  fontWeight: 700,
  fontSize: '0.75rem',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none'
}

const MoreLink = ({ to, children }) => (
  <Link to={to} style={moreBtnStyle}>{children}</Link>
)

const Dashboard = _ => {
    const [readyBirthday, setReadyBirthday] = useState(false)
    const [birthday, setBirthday] = useState([])
    useEffect(() => {
        Controllers.customers.get_customers_birthday().then(res => {
            setBirthday(res.data)
            setReadyBirthday(true)
        })
    }, [])

    const [readyEvent, setReadyEvent] = useState(false)
    const [events, setEvents] = useState([])
    useEffect(() => {
        Controllers.event.get_event_populated().then(res => {
            setEvents(res.data)
            setReadyEvent(true)
        })
    }, [])

    const [foro, setForo] = useState([])
    const [readyForo, setReadyForo] = useState(false)
    useEffect(() => {
        Controllers.foro.get_foro_main().then(res => {
            setForo(res.data)
            setReadyForo(true)
        })
    }, [])

    const [noti, setNoti] = useState([])
    const [readyNoti, setReadyNoti] = useState(false)
    useEffect(() => {
        Controllers.noti.get_noti_main().then(res => {
            setNoti(res.data)
            setReadyNoti(true)
        })
    }, [])

    const [product, setProduct] = useState([])
    const [readyProduct, setReadyProduct] = useState(false)
    useEffect(() => {
        Controllers.product.get_product_seller().then(res => {
            setProduct(res.data)
            setReadyProduct(true)
        })
    }, [])

    const [sale, setSale] = useState([])
    const [readySale, setReadySale] = useState(false)
    useEffect(() => {
        Controllers.sale.get_sale_dashboard().then(res => {
            setSale(res.data)
            setReadySale(true)
        })
    }, [])

    const [eventIndex, setEventIndex] = useState(0)

    const eventCurrent = useMemo(() => {
        if (events.length === 0) {
            return {}
        }

        return events[eventIndex]
    }, [events, eventIndex])

    const [value, onChange] = useState(new Date());

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [dataUpdated, setDataUpdated] = useState({})

    const handleGet = e => {
        let { idProduct } = e.currentTarget.dataset

        Controllers.product.get_product_id({ p_id_product: idProduct }).then(res => {
            setDataUpdated({ data: res.data })
            setDrawerOpen(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
        })
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Inicio"
            subtitle="Eventos, foro, noticias, productos y resultados en un vistazo."
        />
        <div className="form-row">
        <div className="col-12 col-lg-6">
            <div className="form-row">
                <ReactPlaceholder ready={readyEvent} rows={15} showLoadingAnimation>
                    {events.length > 0 ? <div className="col-12 mb-4">
                        <div className="sp-surface-enter" style={{
                            position: 'relative',
                            borderRadius: 20,
                            overflow: 'hidden',
                            boxShadow: '0 8px 30px rgba(0,0,0,.06)'
                        }}>
                            <img src={Helpers.config.resourcesUrl({ url: eventCurrent.file_images })} alt="" style={{
                                width: '100%',
                                display: 'block',
                                borderRadius: 20,
                                objectFit: 'cover',
                                maxHeight: 320
                            }} />
                            <div className="text-white" style={{
                                position: 'absolute',
                                bottom: 50,
                                right: '10%'
                            }}>
                                <Link className="text-decoration-none" to={Helpers.config.convertUrl({ url: '/evento/' + eventCurrent.token_event })}>
                                    <h3 className="text-right text-white font-weight-bold" style={{ maxWidth: 300 }}>{eventCurrent.name_event}</h3>
                                </Link>
                                <hr style={{ maxWidth: 300, minWidth: 200, height: '2px', background: primary, border: 0 }} />
                            </div>
                            <div className="text-white d-flex justify-content-center" style={{
                                position: 'absolute',
                                bottom: 10,
                                width: '100%'
                            }}>
                                <div>
                                    {React.Children.toArray(events.map((e, i) => <i className={`${eventIndex === i ? 'fas fa-dot-circle' : 'far fa-circle'} mr-2 cur-pointer`} onClick={_ => setEventIndex(i)}></i>))}
                                </div>
                            </div>

                            <div className="text-white d-flex flex-column justify-content-center" style={{
                                position: 'absolute',
                                left: 20,
                                height: '100%',
                                cursor: 'pointer',
                                top: 0
                            }} onClick={_ => setEventIndex(eventIndex - 1 < 0 ? events.length - 1 : eventIndex - 1)}>
                                <i className="fa fa-chevron-left"></i>
                            </div>
                            <div className="text-white d-flex flex-column justify-content-center" style={{
                                position: 'absolute',
                                right: 20,
                                height: '100%',
                                cursor: 'pointer',
                                top: 0
                            }} onClick={_ => setEventIndex(eventIndex + 1 >= events.length ? 0 : eventIndex + 1)}>
                                <i className="fa fa-chevron-right"></i>
                            </div>
                        </div>
                    </div> : ''}
                </ReactPlaceholder>
                <div className="col-lg-7 col-md-6 col-12 mb-4">
                    <SurfaceCard
                        className="mb-4"
                        title={
                            <div>
                                <div style={eyebrowStyle}>Comunidad</div>
                                <h5 style={sectionTitleStyle}>Nuestro Foro</h5>
                                <h6 style={{ margin: 0, color: muted, fontWeight: 500, fontSize: '0.85rem' }}>Dudas recientes</h6>
                            </div>
                        }
                        actions={
                            <MoreLink to={Helpers.config.convertUrl({ url: '/foro' })}>Ver Más</MoreLink>
                        }
                        noPadding
                    >
                        <ul className="list-group list-group-flush">
                            <ReactPlaceholder ready={readyForo} showLoadingAnimation rows={20} className="p-3">
                                {React.Children.toArray(foro.map(f => {
                                    return <li className="list-group-item d-flex pt-4 pb-4" style={{ borderColor: '#E5E7EB' }}>
                                        <div>
                                            <img src={Helpers.config.resourcesUrl({ url: f.file_photo_foro })} width="40" alt="" style={{
                                                borderRadius: 50
                                            }} />
                                        </div>
                                        <div className="d-flex flex-column pl-3" style={{ maxWidth: 170 }}>
                                            <h6 style={nameStyle}>
                                                <strong>{f.full_name_cust}</strong>
                                            </h6>
                                            <Link to={Helpers.config.convertUrl({ url: '/foro/' + f.token_foro })}>
                                                <h6 className="font-weight-bold text-danger">{f.name_foro}</h6>
                                            </Link>
                                            <span className="f-size-11">{f.observation_foro}</span>
                                        </div>
                                    </li>
                                }))}
                            </ReactPlaceholder>
                        </ul>
                    </SurfaceCard>

                    <SurfaceCard
                        title={
                            <div>
                                <div style={eyebrowStyle}>Avisos</div>
                                <h5 style={sectionTitleStyle}>Noti Súper</h5>
                            </div>
                        }
                        actions={
                            <MoreLink to={Helpers.config.convertUrl({ url: '/noti-historico' })}>Ver Más</MoreLink>
                        }
                        noPadding
                    >
                        <ul className="list-group list-group-flush">
                            <ReactPlaceholder ready={readyNoti} showLoadingAnimation rows={20} className="p-3">
                                {React.Children.toArray(noti.map(f => {
                                    return <li className="list-group-item d-flex pt-4 pb-4" style={{ borderColor: '#E5E7EB' }}>
                                        <div>
                                            <img src={Helpers.config.resourcesUrl({ url: f.file_images })} width="50" height="50" alt="" style={{
                                                borderRadius: 50,
                                                objectFit: 'cover'
                                            }} />
                                        </div>
                                        <div className="d-flex flex-column pl-3" style={{ maxWidth: 170 }}>
                                            <Link to={Helpers.config.convertUrl({ url: '/noti/' + f.token_noti })}>
                                                <h6 style={nameStyle}>
                                                    <strong>{f.name_noti}</strong>
                                                </h6>
                                            </Link>
                                            <span className="f-size-11">{f.date_created}</span>
                                        </div>
                                    </li>
                                }))}
                            </ReactPlaceholder>
                        </ul>
                    </SurfaceCard>
                </div>
                <div className="col-lg-5 col-md-6 col-12 mb-4">
                    <SurfaceCard
                        title={
                            <div style={{ textAlign: 'center', width: '100%' }}>
                                <div style={eyebrowStyle}>Catálogo</div>
                                <h5 style={sectionTitleStyle}>Productos Nuevos</h5>
                            </div>
                        }
                        noPadding
                    >
                        <ul className="list-group list-group-flush">
                            <ReactPlaceholder ready={readyProduct} showLoadingAnimation rows={20} className="p-3">
                                {React.Children.toArray(product.map(p => {
                                    return <li className="list-group-item d-flex pt-4 pb-4 cur-pointer hover-effect" style={{ borderColor: '#E5E7EB' }} onClick={handleGet} data-id-product={p.id_product}>
                                        <div>
                                            <img src={Helpers.config.resourcesUrl({ url: p.file_images })} width="50" height="50" alt="" style={{
                                                borderRadius: 50,
                                                objectFit: 'cover'
                                            }} />
                                        </div>
                                        <div className="d-flex flex-column pl-3" style={{ maxWidth: 170 }}>
                                            <h6 style={nameStyle}>
                                                <strong>{p.name_product}</strong>
                                            </h6>
                                            <span className="f-size-11">{p.observation_product}</span>
                                        </div>
                                    </li>
                                }))}
                            </ReactPlaceholder>
                        </ul>
                    </SurfaceCard>
                </div>
            </div>
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-4">
            <SurfaceCard
                title={
                    <div>
                        <div style={eyebrowStyle}>Ventas</div>
                        <h5 style={sectionTitleStyle}>Resultados Semanales</h5>
                    </div>
                }
                noPadding
            >
                <ReactPlaceholder showLoadingAnimation ready={readySale}>
                    {sale.length === 0 ? <div className="p-3">
                        <div className="alert alert-warning mb-0">
                            No hay ventas registradas
                        </div>
                    </div> : <ul className="list-group list-group-flush">
                        {React.Children.toArray(sale.map(s => {
                            let color = 'secondary'
                            switch (s.type_sale) {
                                case 'Negro':
                                    color = 'dark'
                                    break;

                                case 'Rojo':
                                    color = 'danger'
                                    break;

                                case 'Estrella':
                                    color = 'warning'
                                    break;
                            }

                            return <li className="list-group-item d-flex pt-4 pb-4" style={{ borderColor: '#E5E7EB' }}>
                                <div>
                                    <img src={Helpers.config.resourcesUrl({ url: s.image_sale })} width="50" height="50" alt="" style={{
                                        borderRadius: 50,
                                        objectFit: 'cover'
                                    }} />
                                </div>
                                <div className="d-flex flex-column pl-3" style={{ maxWidth: 170 }}>
                                    <h6 style={nameStyle}>
                                        <strong>{s.description_sale}</strong>
                                    </h6>
                                    <span className="f-size-11">{s.amount_sale}</span>
                                    <span className="f-size-11 mt-1">
                                        <StatusPill tone={color}>{s.type_sale}</StatusPill>
                                    </span>
                                </div>
                            </li>
                        }))}
                    </ul>}
                </ReactPlaceholder>
            </SurfaceCard>
        </div>
        <div className="col-lg-3 col-md-6 col-12">
            <div className="sp-surface-enter" style={{
                background: '#fff',
                borderRadius: 20,
                boxShadow: '0 8px 30px rgba(0,0,0,.06)',
                padding: 12,
                overflow: 'hidden'
            }}>
                <Calendar
                    onChange={onChange}
                    value={value}
                />
            </div>
            <div className="mt-4 mb-4">
                <SurfaceCard
                    title={
                        <div>
                            <div style={eyebrowStyle}>Equipo</div>
                            <h5 style={sectionTitleStyle}>Próximos Cumpleaños</h5>
                        </div>
                    }
                    noPadding
                >
                    <ul className="list-group list-group-flush">
                        {birthday.length === 0 ? <li className="list-group-item d-flex pt-4 pb-4">
                            <div className="alert alert-warning mb-0">
                                No hay cumpleaños cercanos.
                            </div>
                        </li> : <ReactPlaceholder ready={readyBirthday} showLoadingAnimation rows={20} className="p-3">
                            {React.Children.toArray(birthday.map(b => <li className="list-group-item d-flex pt-4 pb-4" style={{ borderColor: '#E5E7EB' }}>
                                <div>
                                    <img src={Helpers.config.resourcesUrl({ url: b.file_photo_cust })} width="40" alt="" style={{
                                        borderRadius: 50,
                                        objectFit: 'cover'
                                    }} />
                                </div>
                                <div className="d-flex flex-column pl-3" style={{ maxWidth: 170 }}>
                                    <h6 style={nameStyle}>
                                        <strong>{b.full_name_cust}</strong>
                                    </h6>
                                    <span className="f-size-11">{b.email_cust}</span>
                                    <span className="mt-1">
                                        <i className="fas fa-birthday-cake mr-1"></i>{b.date_birthday_cust}
                                        <span className="ml-2">
                                            <StatusPill tone={b.day === 'today' ? 'success' : (b.day === 'tomorrow' ? 'warning' : 'info')}>
                                                {b.day === 'today' ? 'Hoy' : (b.day === 'tomorrow' ? 'Mañana' : 'Pronto')}
                                            </StatusPill>
                                        </span>
                                    </span>
                                </div>
                            </li>))}
                        </ReactPlaceholder>}
                    </ul>
                </SurfaceCard>
            </div>
        </div>
        <SideDrawer
            open={drawerOpen}
            onClose={_ => setDrawerOpen(false)}
            title="Información de Producto"
            subtitle="Vista previa del producto seleccionado."
        >
            <ProductForm showPreview {...dataUpdated} />
        </SideDrawer>
    </div>
    </>
}

export default Dashboard
